import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "../shared/type";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardUpDown: React.FC<Props> = ({ props }) => {
  return (
    <>
      {props.map((item, key: number) => {
        const params = new URLSearchParams({
          id: String(item.id),
          category: item.category,
          slug: item.urlinform,
        });
        return (
          <Link
            rel="stylesheet"
            target="_top"
            // to={{
            //   pathname: `/article`,
            //   // search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
            //   search: params.toString(),
            // }}
            to={`/article/${item.urlinform}`}
            key={key}
          >
            <div className="w-full max-w-[560px] h-[490px] flex flex-col border-[1px] rounded-xl shadow-lg overflow-hidden hover:shadow-xl transform transition-transform duration-500 ease-in-out hover:-translate-y-2 cursor-pointer">
              <div className="w-full h-[64%]">
                <LazyImage
                  src={item.images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover rounded-t-xl"
                />
              </div>
              <div className="w-full h-[36%] flex justify-center items-center rounded-b-xl bg-white">
                <div className="px-8">
                  <div className="flex flex-col">
                    <span className="text-base font-bold text-[#c9b077] mb-0">
                      {item.category}
                    </span>
                    <span className="line-clamp-2">
                      <b className="text-xl font-bold"> {item.title}</b>
                      <i className="text-opacity-0 text-[#c84e47] text-[10px]">
                        | Explore Asia
                      </i>
                    </span>

                    <span className="w-full mt-2 text-xs font-medium text-[#363f4d] line-clamp-3">
                      {item.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </>
  );
};

export default CardUpDown;
